<script>
   /**************************************************************/
   /* Svelte component for AcceptancePlot settings               */
   /**************************************************************/

   import Container from '../../../shared/controls/Container.svelte';
   import Select from '../../../shared/controls/Select.svelte';

   export let params;
   export let res;

   let isAlt = true;
   let scope = 'objects';
   let transType = 'no';
   let showLabels = 'hide';
   let resID = res ? Object.keys(res)[0] : '';
   let colorBy = 'roles';

   $: params = {
      isAlt,
      scope,
      transType,
      showLabels,
      colorBy,
      resID
   }

   $: colorByValid = res['alt'].classNames &&
      res['alt'].classNames.length > 1 &&
      res['alt'].classNames.length < 9;
</script>

{#if res  }
<Container label="">
   <p class="title">Acceptance plot</p>
</Container>
{#if Object.keys(res).length > 1 }
<Container label='Results:'>
   <Select id='resType' bind:value={resID} options={Object.keys(res)} />
</Container>
{/if}
<Container label='Transform:'>
   <Select id='limType' bind:value={transType} options={['no', 'log']} />
</Container>
<Container label='Labels:'>
   <Select id='showLabels' bind:value={showLabels} options={['hide', 'show']} />
</Container>
{#if colorByValid}
<Container label='Color by:'>
   <Select id='colorby' bind:value={colorBy} options={['roles', 'classes']} />
</Container>
{/if}
{/if}

